export const INVITE_STATUS = {
  SENDING: 'Enviados',
  ACCEPTED: 'Aceitos',
  EXPIRED: 'Expirado',
};
